import { FileText, ShieldCheck } from "lucide-react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { PUBLISHER_TABS } from "../../misc/constants";

const TAB_ICON = { kyc: ShieldCheck, invoices: FileText };

const PublisherTabs = ({ activeTab, onChange, counts }) => (
    <div role="tablist" className="mt-6 inline-flex rounded-lg bg-light p-1">
        {PUBLISHER_TABS.map((tab) => {
            const Icon = TAB_ICON[tab.id];
            const active = activeTab === tab.id;
            return (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    onClick={() => onChange(tab.id)}
                    className={classnames(
                        "inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-colors",
                        active ? "bg-white text-gray-900 shadow-sm" : "text-muted hover:text-gray-700"
                    )}>
                    <Icon className="h-4 w-4" />
                    {tab.label}
                    {Number.isFinite(counts[tab.id]) && <span className="text-xs text-muted">({counts[tab.id]})</span>}
                </button>
            );
        })}
    </div>
);

PublisherTabs.propTypes = {
    activeTab: PropTypes.string.isRequired,
    onChange : PropTypes.func.isRequired,
    counts   : PropTypes.object.isRequired
};

export default PublisherTabs;
